import type { WorkerPoolResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import type { FormFieldProps } from "~/components/form";
import WorkerPoolSelect, { BoundWorkerPoolSelect } from "../form/WorkerPoolSelect/WorkerPoolSelect";
interface WorkPoolInputProps extends FormFieldProps<string> {
    label: string;
    warning?: string;
    allowClear: boolean;
    defaultValueIndicator: JSX.Element | undefined;
    hideSearch?: boolean;
    doBusyTask(action: () => Promise<void>): Promise<boolean>;
    validate?: ((value: string) => string) | ((value: string | null) => string);
    onValidate?(value: string): void;
    items: () => Promise<WorkerPoolResource[]>;
    onRequestRefresh: () => Promise<boolean>;
    allowBoundVariables: boolean;
}
function WorkerPoolInput(props: WorkPoolInputProps) {
    const { value, label, warning, allowClear, defaultValueIndicator, doBusyTask, hideSearch, allowBoundVariables, ...rest } = props;
    const formProps = { ...rest, label };
    return (<>
            {allowBoundVariables ? (<BoundWorkerPoolSelect value={value} warning={warning} allowClear={allowClear} doBusyTask={doBusyTask} {...formProps} hideSearch={hideSearch}/>) : (<WorkerPoolSelect value={value} warning={warning} allowClear={allowClear} doBusyTask={doBusyTask} {...formProps} hideSearch={hideSearch}/>)}
            {defaultValueIndicator}
        </>);
}
export default WorkerPoolInput;
